<template>
  <BaseSimpleLayout class="supplier-create">
    <template #title>仕入先登録</template>
    <template #main>
      <el-form
        ref="formRef"
        :model="createForm"
        :rules="rules"
        size="large"
        label-width="150px"
      >
        <div class="supplier-master-create-form">
          <div>
            <el-form-item label="仕入先名" prop="name">
              <el-input
                v-model="createForm.name"
                autocomplete="off"
                :disabled="isConfirm"
              />
            </el-form-item>
            <el-form-item
              class="supplier-create-tel"
              label="電話番号"
              prop="tel"
            >
              <el-input
                v-model="createForm.tel"
                autocomplete="off"
                maxlength="13"
                :disabled="isConfirm"
                @change="telRestrict()"
              />
            </el-form-item>
            <el-form-item
              label="郵便番号"
              prop="post"
              class="supplier-create-post"
            >
              <el-input
                v-model="createForm.post"
                autocomplete="off"
                maxlength="7"
                :disabled="isConfirm"
                @change="zipRestrict()"
              />
            </el-form-item>
            <el-form-item label="住所" prop="address">
              <el-input
                v-model="createForm.address"
                autocomplete="off"
                :disabled="isConfirm"
              />
            </el-form-item>
            <el-form-item class="supplier-create-fax" label="FAX" prop="fax">
              <el-input
                v-model="createForm.fax"
                autocomplete="off"
                maxlength="12"
                :disabled="isConfirm"
                @change="faxRestrict()"
              />
            </el-form-item>
            <el-form-item
              class="supplier-create-manager-name"
              label="担当者名"
              prop="managerName"
            >
              <el-input
                v-model="createForm.managerName"
                autocomplete="off"
                :disabled="isConfirm"
              />
            </el-form-item>
          </div>
        </div>
        <div v-if="isConfirm" class="button-area">
          <el-button type="info" size="large" @click="isConfirm = false">
            キャンセル
          </el-button>
          <el-button type="primary" size="large" @click="submit()">
            登録
          </el-button>
        </div>
        <div v-else class="button-area">
          <el-button
            class="unit-master-item-create-button-list"
            type="info"
            size="large"
            @click="router.push('/master/supplier')"
          >
            戻る
          </el-button>
          <el-button
            class="unit-master-item-create-button-confirm"
            type="primary"
            size="large"
            @click="changeConfirm(formRef)"
          >
            確認
          </el-button>
        </div>
      </el-form>
    </template>
  </BaseSimpleLayout>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  import router from '@/router';
  import BaseSimpleLayout from '@/components/BaseSimpleLayout.vue';
  import type { FormInstance, FormRules } from 'element-plus';
  import { SupplierPutData } from '@/types/master/supplier';
  import { telRestriction, zipRestriction } from '@/libs/common';

  const store = useStore();
  const formRef = ref<FormInstance>();
  const createForm = ref<SupplierPutData>({
    name: '',
    post: '',
    address: '',
    tel: '',
    fax: '',
    managerName: ''
  });
  const rules = ref<FormRules>({
    name: [{ required: true, message: '仕入先名は必須です。' }],
    post: [
      { required: true, message: '郵便番号は必須です。' },
      {
        min: 7,
        max: 7,
        message: '郵便番号は7桁の半角数字で入力してください。',
        trigger: 'blur'
      }
    ],
    address: [{ required: true, message: '住所は必須です。' }],
    tel: [
      { required: true, message: '電話番号は必須です。' },
      {
        min: 10,
        max: 13,
        message:
          '電話番号は10桁から13桁の半角数字(ハイフン含む)で入力してください。',
        trigger: 'blur'
      }
    ],
    fax: [
      {
        min: 10,
        max: 12,
        message:
          'FAXは10桁から13桁の半角数字(ハイフン含む)で入力してください。',
        trigger: 'blur'
      }
    ],
    managerName: [{ required: true, message: '担当者は必須です。' }]
  });
  const isConfirm = ref(false);

  const changeConfirm = async (formEl: FormInstance | undefined) => {
    if (!formEl) return;
    await formEl.validate((valid) => {
      if (!valid) {
        return false;
      }
      isConfirm.value = true;
    });
  };
  const submit = () => {
    store.dispatch('suppliersMaster/submit', createForm.value);
  };
  const zipRestrict = () => {
    createForm.value.post = zipRestriction(createForm.value.post);
  };
  const telRestrict = () => {
    createForm.value.tel = telRestriction(createForm.value.tel);
  };
  const faxRestrict = () => {
    createForm.value.fax = telRestriction(createForm.value.fax);
  };
</script>
<style lang="scss">
  .supplier-create {
    .supplier-master-create-form {
      display: inline-flex;
    }
    form {
      width: 100%;
      display: inline-block;
    }

    .el-input {
      width: 300px;
      float: left;
    }

    .el-form-item {
      font-weight: 600 !important;
    }

    .supplier-create-post .el-input {
      width: 90px;
      float: left;
    }

    .supplier-create-address {
      .el-input {
        width: 300px;
        float: left;
      }
    }

    .supplier-create-tel {
      .el-input {
        width: 135px;
        float: left;
      }
    }

    .supplier-create-fax {
      .el-input {
        width: 135px;
        float: left;
      }
    }

    .supplier-create-manager-name {
      .el-input {
        width: 200px;
        float: left;
      }
    }

    .button-area {
      margin: 10px 0px;
    }

    .el-button {
      font-weight: 600;
    }
  }
</style>
